import { Component } from '@angular/core';
import { LayoutService } from '../../core/services/layout.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent {
  constructor(public layoutService: LayoutService) {}

  /**
   * Il collegamento di salto deve spostare anche il fuoco, non solo la vista:
   * con un'applicazione a pagina singola l'ancora cambia l'indirizzo ma lascia
   * il fuoco dov'era, e il tabulatore successivo tornerebbe nel menu.
   */
  focusMainContent(event: Event): void {
    event.preventDefault();
    const main = document.getElementById('contenuto-principale');
    if (!main) {
      return;
    }
    main.focus();
    main.scrollIntoView({ block: 'start' });
  }
}
